import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';

const isConsultaAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleConsultaError = (xhr, reject, rejectMessage) => {
  if (isConsultaAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, {message: rejectMessage}]);
};

const ajaxConsultaEvent = (type, pp, ll, dd, tk, parseType = 'raw', rejectMessage = 'Dados não localizados', extraData = {}, url = `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`, includeRouteData = true) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url,
      type,
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: includeRouteData ? {
        pp: base64_encode(pp),
        ll: base64_encode(ll),
        dd,
        tk,
        ...extraData,
      } : {
        tk,
        ...extraData,
      },
      success: async function (data, status, xhr) {
        if (parseType === 'raw') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr, status, error) {
        handleConsultaError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, {message: 'Server Error'}]);
  }
});

const RestConsultaPost = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  switch (caminho) {
    case 'espionarA1': {
      const {dataPost} = Arr_;
      const cnpj = dataPost[4];
      return ajaxConsultaEvent('POST', 'consultaNfe', 'consultaA1', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost)), base64_encode(cnpj)])), token);
    }
    case 'espionarCteA1': {
      const {dataPost} = Arr_;
      const cnpj = dataPost[4];
      return ajaxConsultaEvent('POST', 'consultaCte', 'consultaCteA1', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost)), base64_encode(cnpj)])), token);
    }
    case 'espionarNfseNaA1': {
      const dataPost = [...Arr_.dataPost, storage[7]];
      const cnpj = dataPost[1];
      return ajaxConsultaEvent('POST', 'consultaNfse', 'consultaNFSEna', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost)), base64_encode(cnpj)])), token);
    }
    default:
      break;
  }
};

export {RestConsultaPost};
